module.exports = __webpack_public_path__ + "static/media/sos-phone.9f1ad03b.png";